import React, { useContext } from "react";
import background from "./images/background-optimised.jpg";
import download from "./images/download.png";
import explorer from "./images/explorer.png";
import dashboard from "./images/dashboard.png";
import resources from "./images/resources.png";
import Footer from "./shared/components/Footer";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { routeConstants } from "./shared/constants";
import { NavLink } from "react-router-dom";
import { VersionContext } from "./context/VersionContext"; // ✅ Import Version Context

function App() {
  // Version Refresh - context is used by parent components
  // eslint-disable-next-line no-unused-vars
  const versionContext = useContext(VersionContext);

  // Version checking on route changes is now handled by RouteChangeListener component
  // This prevents duplicate version checks and console logs

  // const [key, setKey] = useState(location.pathname); // Force re-render

  // useEffect(() => {
  //   setKey(location.pathname + version); // Change key when version updates
  // }, [version, location.pathname]);
  // // Version Refresh

  return (
    // <div className="relative" key={key}> {/* Force re-render when version changes */}
    <div className="relative"> {/* Force re-render when version changes */}
      <div
        style={{
          height: "calc(100vh - 80.88px)",
          backgroundImage: `url(${background})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
        className="flex flex-col justify-between"
      >
        <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        <div className="flex-1 flex flex-col items-center justify-evenly z-10 px-5">
          <div className="flex flex-col items-center w-full">
          <h1 className="text-7xl text-amber-500">
            <span style={{ color: "white" }}>EXPLORE</span> SOUTH AFRICAN TAX DATA
          </h1>
          <p
            style={{
              width: "80%",
              textAlign: "center",
              fontSize: 20,
              color: "white",
              padding: "4px 10px",
            }}
            className="font-sans"
          >
            There is a glaring gap in the availability of credible spatial economic data in South Africa. This ambitious project draws on administrative tax records to generate new insights about the economy of South African cities and regions
          </p>
          <div className="bg-white bg-opacity-20 rounded px-5 py-8 border-0 flex justify-between" style={{ width: "70%", backgroundColor: "#282F3980" }}>
            <NavLink to={routeConstants.DASHBOARDS_LANDING}>
              <div className="px-5 py-2 flex flex-col items-center">
                <img src={dashboard} alt="dashboard" />
                <h3 className="text-white text-lg mt-5 font-sans">DASHBOARDS</h3>
                <p
                  style={{
                    width: "90%",
                    fontSize: 16,
                    textAlign: "center",
                    color: "white",
                    margin: 0,
                  }}
                  className="font-sans"
                >
                  Go on a journey to discover distinctive features about local economies
                </p>
              </div>
            </NavLink>
            <NavLink to={routeConstants.TAX_DATA_LANDING}>
              <div className="px-5 py-2 flex flex-col items-center">
                <img src={explorer} alt="map explorer" />
                <h3 className="text-white mt-5 text-lg font-sans">MAP EXPLORER</h3>
                <p
                  style={{
                    width: "90%",
                    fontSize: 16,
                    textAlign: "center",
                    color: "white",
                    margin: 0,
                  }}
                  className="font-sans"
                >
                  An open ended tool to visualize spatial tax data based on your interests
                </p>
              </div>
            </NavLink>
            <NavLink to={routeConstants.DOWNLOAD_DATA_LANDING}>
              <div className="px-5 py-2 flex flex-col items-center">
                <img src={download} alt="download data" />
                <h3 className="text-white mt-5 text-lg font-sans">DOWNLOAD DATA</h3>
                <p
                  style={{
                    width: "90%",
                    fontSize: 16,
                    textAlign: "center",
                    color: "white",
                    margin: 0,
                  }}
                  className="font-sans"
                >
                  Get access to the raw data, metadata and methodology user guide
                </p>
              </div>
            </NavLink>
            <NavLink to={routeConstants.RESOURCES}>
              <div className="px-5 py-2 flex flex-col items-center">
                <img style={{ padding: "1rem", width: "100px" }} src={resources} alt="resources" />
                <h3 className="text-white mt-5 text-lg font-sans">RESOURCES</h3>
                <p
                  style={{
                    width: "90%",
                    fontSize: 16,
                    textAlign: "center",
                    color: "white",
                    margin: 0,
                  }}
                  className="font-sans"
                >
                  Explore research and related content based on spatial tax data
                </p>
              </div>
            </NavLink>
          </div>
          </div>
          <NavLink to={routeConstants.ABOUT_THE_PROJECT}>
            <button
              style={{
                border: "2px solid #F0A400",
                borderRadius: 50,
                padding: 8,
                paddingLeft: 14,
                color: "#F0A400",
              }}
              className="font-sans"
            >
              Learn More
              <ArrowForwardIosIcon />
            </button>
          </NavLink>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default App;
